export enum generalIframeQueryParams {
  skipThemeSetup = 'skipThemeSetup',
  brandUrl = 'brandUrl',
}
